export default {
    // $ 公共
    general_button_cancel: 'Cancel',
    general_button_sure: 'Confirm',
    general_button_close: 'Close',
    general_text_update_faild: 'Update failed',
    general_button_done: 'Done',
    general_text_ordered: 'Ordered',
    general_text_next_turn_time: 'Round',
    general_text_get_limit_rule_failed: 'Failed to get round rules',
    general_text_customer_not_exist: 'User {{n}} does not exist',
    general_text_can_not_get_rules_of_dish: 'Unable to get dish rule data',
    general_text_no_data: 'No data found',

    // $ 历史订单
    order_history_page_text_no_make: 'Not made',
    order_history_page_text_make_complete: 'Delivering',
    order_history_page_text_service_complete: 'Served',
    order_history_page_text_unable_make: 'Cancelled',
    order_history_page_text_pause_make: 'Suspended',
    order_history_page_text_waiter: 'Waiter',
    order_history_page_text_customer: 'Customer',
    order_history_page_text_extra: 'Extra fee',
    order_history_page_text_order_devices: 'Other devices',
    history_order_you: 'Customer',
    history_order_round: 'The {{round}} Round',
    history_order_total: 'in total {{number}} dishes',

    // $ 呼叫服务
    service_page_text_call_service_select: 'Call service (optional)',
    service_page_text_insert_texts: 'Please enter the content (optional)',
    service_page_text_call_waiter: 'Call waiter',
    service_page_text_call_service: 'Call service',
    service_page_text_table_name: 'Table name',
    service_page_text_Please_select_a_service: 'Please select a service',
    service_page_text_Your_requirement: 'Your requirement (optional)',
    service_page_text_call_service_success_message: 'Call succeeded',
    service_page_input_placeholder_message: 'Enter your demands...',

    // $ 购物车
    order_cart_page_text_total: 'Total',
    order_cart_page_text_complete_order: 'You have completed order for the current turn',
    order_cart_page_text_round_max_order_count: 'Limit order of round: {{n}}',
    order_cart_page_text_round_max_number_exceed: 'Exceeded the limit of order',
    order_cart_page_text_similar_dish_number_exceed: 'Exceeded the limit of category',
    order_cart_page_text_same_dish_number_exceed: 'The dish has exceeded the maximum order limit',
    order_cart_page_text_max_rounds_exceed: 'Exceeded limit of round',
    order_cart_page_text_dish_not_exists: 'Dish does not exist',
    order_cart_page_text_commit_cart_fail: 'Cart send failed',
    order_cart_page_text_commit_success: 'Send successfully',
    order_cart_page_text_cart_not_data: 'No data',
    order_cart_page_text_select_preferences: 'Click on the dish name to choose your preference condiment',
    order_cart_page_text_disable_edit_second: 'After {{s}} seconds to enter the next round',
    order_cart_page_text_print_credential_fail: 'Failed to print ticket',
    order_cart_page_text_dish_remarks: 'Dishes remarks',
    order_cart_page_text_self: 'Self',
    order_cart_page_text_cannot_at_the_same_time: 'Please do not submit cart or modify cart items at the same time',
    order_cart_page_text_is_submitting: 'The order is being submitted',
    order_cart_page_text_round_rules: 'You can only send it once per round. You still have an unused quantity of dishes to order. Do you want to send it?',
    order_cart_page_text_clear: 'Clear',
    order_cart_page_text_delete: 'Remove',
    order_cart_page_text_exe_dishes_commit: 'There are excess dishes, whether to continue to submit',
    order_cart_page_text_confirm_modification: 'Confirm',
    order_cart_page_text_sync_round_info_success: 'The round has been updated successfully',
    order_cart_page_text_dish_is_sold_out: 'The dish is sold out',
    order_cart_page_text_sold_out: 'Sold out',
    order_cart_Page_text_verify_sold_out_dishes_message: 'The number of dishes \'{{menu}}\' that can be ordered is {{excessedNum}};',

    // $ 点餐
    menu_page_text_please_select_your_id: 'Please enter your ID',
    menu_page_text_check_tip_id: 'Forgot ID? Check your order history to recall',
    menu_page_text_dishes_copy: '{{n}} has been ordered {{1}} time/s in this round',
    menu_page_text_more_than_half_ordered: '{{n}} people have ordered {{dish}}',
    menu_page_text_not_show: 'Don\'t show this message again',
    menu_page_text_under_review_wait: 'Reviewing, please wait',
    menu_page_text_order_success_created_jump: 'The order is created successfully, jump to the menu page',
    menu_page_text_order_does_not_exist: 'The order does not exist or the table is reseted, please reopen',
    menu_page_text_review_rejected: 'Review rejected',
    menu_page_text_under_review: 'Under review',
    menu_page_text_locked_state: 'The order is locked, you can view menu freely',
    menu_page_text_reset_send: 'Resend review',
    menu_page_text_reset_send_success: 'Resent successfully',
    menu_page_text_approved: 'Approved',
    menu_page_text_order_unlocked: 'Order has been unlocked',
    menu_page_text_table_invalid: 'Invalid table',
    menu_page_text_customer_id_occupy: 'The ID is already in use',
    menu_page_text_dish_time_disable: 'Some menus have been disabled due to the kitchen being closed',
    menu_page_text_notice_time: 'The kitchen will close in {{time}} minutes. Please order your dishes before the kitchen closes',
    menu_page_text_allergen_filter_label_message: 'Select the dishes to be filtered',
    menu_page_text_allergen: 'Allergens',
    menu_page_text_ingredents: 'Other dish labels',
    menu_page_text_ingredent_filter_label_message: 'Select the dishes to be filtered',
    menu_page_text_filter: 'Filter',
    menu_page_text_dish_exceeded: 'The item you are adding to the shopping cart has exceeded the limit of the quantity of this item. You may be charged an additional fee if you continue',

    // $ 扫码入口页
    home_page_text_please_select_menu: 'Please select the menu',
    home_page_text_number_of_adults: 'Number of adults',
    home_page_text_number_of_child: 'Number of children',
    home_page_text_adult_price: 'Adult price',
    home_page_text_child_price: 'Child price',
    home_page_text_normal: 'Standard',
    home_page_text_special: 'Special',
    home_page_text_table_pause_use: 'The table is not available',
    home_page_text_order_now: 'Order now!',
    home_page_text_get_menu_fail: 'Failed to load menu, please try again.',
    home_page_text_announcement: 'Announcement',

    // $ 公告页
    notice_page_text_no_picture: 'No picture',

    // $ 过敏源种类
    text_gluten: "Gluten",
    text_crustaceans: "Crustaceans",
    text_eggs: "Eggs",
    text_fish: "Fish",
    text_peanuts: "Peanuts",
    text_soya: "Soya",
    text_milk: "Milk",
    text_tree_nuts: "Nuts",
    text_celery: "Celery",
    text_mustard: "Mustard",
    text_sesame: "Sesame",
    text_sulphites: "Sulphites",
    text_lupin: "Lupin",
    text_molluscs: "Molluscs",
    text_mild_spicy: "Mild spicy",
    text_medium_spicy: "Medium spicy",
    text_very_spicy: "Heavy spicy",
    text_frozen_origin: "Frozen origin",
    text_blast_freezing: "Blast Freezing",
    text_vegetarian: "Vegetarian",
    text_vegan: "Vegan",
    text_gluten_free: "Gluten free",
    text_raw: "Raw food",
    text_cooked: "Cooked food",
    text_additives: "Food additives",
    text_colourants: "Food colourants",

    // 新手引导
    novice_guide_text_select_menu: 'Select menu',
    novice_guide_text_select_normal_menu: 'Select standard menu',
    novice_guide_text_select_special_menu: 'Select special menu',
    novice_guide_text_select_number_of: 'Choose the number of guest ',
    novice_guide_text_order: 'Order',
    novice_guide_text_announcement: 'Notification',
    novice_guide_text_cart: 'Cart',
    novice_guide_text_history: 'Order history',
    novice_guide_text_call: 'Call service ',
    novice_guide_text_switch_dish_mode: 'Switch the menu display mode',
    novice_guide_text_first_menu: 'Select main menu',
    novice_guide_text_switch_user: 'Show current user',
    novice_guide_text_round_dish: 'Check the number of round',
    novice_guide_text_click_dish_card_add: 'Click this area to order dishes',
    novice_guide_text_click_dish_card_reduce: 'Click this area to remove dishes',
    novice_guide_text_enlarge_dish_card: 'Click this area to view the dish details',
    novice_guide_text_click_cancel: 'Click to cancel the guide',
    novice_guide_text_reduce_order: 'Reduce order',
    novice_guide_text_increase_order: 'Increase order',
    novice_guide_text_table: 'Table',
    novice_guide_text_enter_number: 'Enter the number of guests',
    novice_guide_text_swipe_to_switch: 'Swipe to switch',
    novice_guide_text_home: 'Homepage',

    // 自助开台
    auto_open_page_text_featured_dishes: 'Featured dishes',
    auto_open_page_text_order_now: 'Order Now',
    auto_open_page_text_opening_hours: 'Available times for order',
    auto_open_page_text_media: 'Social media',
    auto_open_page_text_website: 'Official website',
    auto_open_page_text_reservation: 'Reservation',
    auto_open_page_text_takeaway: 'Takeaway',
    auto_open_page_text_without_menu: 'No menu is selectable at current time',
    auto_open_page_adults: 'Adults',
    auto_open_page_other: 'Other',
    auto_open_page_children: 'Children',
    auto_open_page_text_menu: 'Menu',
    text_persons: 'Persons',
    auto_open_page_open_table: 'Open table',
    auto_open_page_select: 'Select',
    auto_open_page_see_more: 'View more',
    auto_open_page_text_disabled_message: 'Self-service table opening is disabled, please contact the staff.',

    // 临时密码功能
    auto_open_page_text_set_temporary_password: 'Create a temporary PIN',
    auto_open_page_text_input_temporary_password: 'Please enter the PIN',
    auto_open_page_text_reset_temporary_password: 'Reset PIN',
    auto_open_page_text_cancel_temporary_password: 'Cancel PIN',
    auto_open_page_text_forgot_password: 'Forgot PIN',
    auto_open_page_text_input_password: 'Please enter a 4-digit number',
    auto_open_page_text_go_back: 'Back',
    auto_open_page_text_confirm_changes: 'Confirm',
    auto_open_page_incorrect_pin: 'Incorrect PIN',
    auto_open_page_modification_failed: 'Modification failed',
    auto_open_page_modification_succeed: 'Modification succeed',
    auto_open_page_button_confirm: 'Confirm',
    auto_open_page_employee_account: 'User',
    auto_open_page_employee_password: 'Password',
    auto_open_page_pin: 'PIN',

    // 复合型营业时间
    general_text_all_day_business: 'Open 24 hours',
    general_text_business_hours: "Fixed business hours",
    general_text_compound_business_hours: "Weekly business hours",

    // 餐厅区域
    general_text_You_are_not_in_the_restaurant_area_unable_to_order: 'You are not in the restaurant area, unable to order',
    general_text_Getting_your_location_failed: 'Getting your location failed',

    general_text_poor_network: 'Unable to connect to server or unstable network, please try again later',

    // 点餐 - 套餐相关
    menu_page_text_setMenu: 'Menu',
    menu_page_text_choose_the_products: 'Select product',
    menu_page_text_add_to_cart: 'Add to cart',
    menu_page_text_set_menu_required: 'required',
}